module.exports = "/_next/static/images/rooster-61cb316851d1b37de49187c690aff6ce.png";